// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da
import { notification } from 'antd';
import { MASTER_PAGE_NOTIFICACAO } from './constants';

export function notificacao(type, titulo, conteudo, duracao) {
  notification[type]({
    message: titulo,
    description: conteudo,
    duration: duracao ? duracao : 3,
  });
  return {
    type: MASTER_PAGE_NOTIFICACAO,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MASTER_PAGE_NOTIFICACAO:
      return {
        ...state,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/master-page/redux/notificacao.js